<app-top-navbar></app-top-navbar>

<div class="main-content">
  <div class="header">

  </div>

  <div class="container-fluid">
    <router-outlet></router-outlet>
  </div>
</div>
